import RestApiModel from "@/api/Model/RestApiModel";
import api from "@/api";

class Product extends RestApiModel {
  static getResourceEndpoint() {
    return '/products-ipr';
  }

  static listBySection(params = {}) {
    const endpoint = this.getResourceEndpoint()+'/by-section';
    return api.get(endpoint, params);
  }

  /**
   * @param id
   * @param isEnabled
   * @returns {*}
   */
  static enable(id, isEnabled) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/enable`, {isEnabled});
  }
}

export default Product;
